import { useEffect, useRef } from 'react';

const ChatSearchBar = ({
  value,
  onChange,
  placeholder = 'Type / for search modes',
  tags = [],
  activeTag = '',
  onTagSelect = () => {},
  onSubmit = () => {},
  disabled = false,
  className = '',
}) => {
  const textareaRef = useRef(null);
  const maxHeightPx = 120; // ~5 lines at 24px line height

  const handleSubmit = (e) => {
    e.preventDefault();
    if (disabled) return;
    onSubmit();
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      if (disabled) return;
      onSubmit();
    }
  };

  useEffect(() => {
    const el = textareaRef.current;
    if (!el) return;
    el.style.height = 'auto';
    const newHeight = Math.min(el.scrollHeight, maxHeightPx);
    el.style.height = `${newHeight}px`;
    el.style.overflowY = el.scrollHeight > maxHeightPx ? 'auto' : 'hidden';
  }, [value]);

  return (
    <div className={`flex w-full max-w-6xl flex-col ${className}`}>
      <form
        onSubmit={handleSubmit}
        className={`flex items-center gap-3 rounded-2xl border border-white/10 bg-white/5 px-4 py-2 shadow-soft }`}
      >
        <textarea
          ref={textareaRef}
          className="w-full resize-none bg-transparent text-base leading-relaxed text-slate-100 outline-none placeholder:text-slate-400 md:text-sm"
          placeholder={placeholder}
          value={value}
          rows={1}
          style={{ maxHeight: `${maxHeightPx}px`, minHeight: '26px' }}
          onChange={(e) => onChange(e.target.value)}
          onKeyDown={handleKeyDown}
          disabled={disabled}
        />
        <button
          type="submit"
          disabled={disabled || !value.trim()}
          className="flex h-9 w-9 items-center justify-center rounded-full bg-white/10 text-slate-100 hover:bg-white/20 disabled:opacity-60"
        >
          <span className="inline-block -rotate-90 text-base font-semibold">➜</span>
        </button>
      </form>
    </div>
  );
};

export default ChatSearchBar;
